<template lang="pug">
div
  Form(:data="id", :isSubmitting="isSubmitting", :isEdit="true", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useIDEdit from './useIDEdit'

export default {
  components: {
    Form,
  },

  setup() {
    const { show, update, id, isSubmitting } = useIDEdit()

    onMounted(show)

    return {
      id,
      update,
      isSubmitting,
    }
  },
}
</script>
